import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MaterialModule } from 'libs/material/src/lib/material.module';
import { REFINEMENT_SMALL_PACKAGE_PRICE, REFINEMENT_LARGE_PACKAGE_PRICE, REFINEMENT_DATA_PACKAGE_PRICE } from 'libs/sap/src/lib/services/sap.fixed-prices.constants';
import { ConfirmDialogComponent } from 'libs/ux-components/src/lib/components/confirm-dialog/confirm-dialog.component';

@Component({
	selector: 'tm2-refinement-release',
	templateUrl: 'refinement-release.component.html',
	standalone: true,
	imports: [
		CommonModule,
		TranslateModule,
		MaterialModule,
		MatButtonModule,
		MatDialogModule,
		TranslateModule
	],
	styleUrl: "./refinement-release.component.scss"
})

export class RefinementReleaseComponent implements OnInit {
	@Input() plannedAligners: number;
	@Input() isDataVariant: boolean;
	@Output() releaseAction = new EventEmitter<void>();
	@Output() rejectAction = new EventEmitter<void>();

	packagePrice: number;

	constructor(
		private dialog: MatDialog,
		private translateService: TranslateService
	) { }

	ngOnInit() {
		this.packagePrice = this.determinePackagePrice();
	}

	private determinePackagePrice(): number {
		if (this.isDataVariant) {
			return REFINEMENT_DATA_PACKAGE_PRICE;
		} else if (this.plannedAligners <= 10) {
			return REFINEMENT_SMALL_PACKAGE_PRICE;
		} else {
			return REFINEMENT_LARGE_PACKAGE_PRICE;
		}
	}

	onReleaseRefinementButtonClicked() {
		const dialogData = {
			title: "RefinementReleaseConfirmationTitle",
			subMessage: `${this.translateService.instant('RefinementReleaseConfirmationMsg', {aligners: this.plannedAligners, price: this.packagePrice})}`,
			no: "Cancel",
			yes: "Order for a fee"
		};
		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			data: dialogData
		});

		dialogRef.afterClosed().subscribe((result) => {
			if (result == "yes") {
				this.releaseAction.emit();
			}
		});
	}

	onRejectRefinementButtonClicked() {
		const dialogData = {
				title: "RefinementRejectConfirmationTitle",
				subMessage: `${this.translateService.instant('RefinementRejectConfirmationMsg')}`,
				no: "Cancel",
				yes: "Yes"
			};
			const dialogRef = this.dialog.open(ConfirmDialogComponent, {
				data: dialogData
			});

			dialogRef.afterClosed().subscribe((result) => {
				if (result == "yes") {
					this.rejectAction.emit();
				}
			});
	}
}
